<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="changeAddMenuDialog({})">
        新增省地区
      </el-button>
    </div>
    <el-table
      :data="routes"
      style="width: 100%; margin-bottom: 20px"
      row-key="id"
      border
      lazy
      :load="load"
      :tree-props="{ children: 'childers', hasChildren: 'hasChildren' }"
    >
      <!-- <el-table-column prop="date" label="日期" sortable width="180">
      </el-table-column> -->
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="code" label="code"> </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row }">
          <el-button type="primary" size="mini" v-if="row.type" @click="changeAddMenuDialog(row)">
            新增
          </el-button>
          <el-button plain size="mini" @click="editMenuAuth(row)"> 修改 </el-button>
          <el-button type="danger" size="mini" @click="deleteMenuAuth(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="menuTitle" :visible.sync="addMenuDialog" width="30%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="code">
          <el-input v-model="form.code" :disabled="!!form.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMenuDialog = false">取 消</el-button>
        <el-button type="primary" @click="addMenu">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let time = null;
import { httpAction } from "@/api/manage";
export default {
  data() {
    return {
      routes: [],
      url: {
        queryProvince: "/pcc/queryPageProvince",
        queryCity: '/pcc/queryPageCity',
        queryCounty: '/pcc/queryPageCounty',
        // addAuth: "/menuAuth/addAuth",
        // updateAuth: '/menuAuth/updateAuth',
        // deleteAuth: '/menuAuth/deleteAuth '
      },
      addMenuDialog: false,
      form: {
        name: "",
        code: "",
        id: null
      },
      menuTitle: '',
      treeMap: new Map()
    };
  },
  mounted() {
    this.getProvinceRoutes();
  },
  methods: {
    async getProvinceRoutes() {
      let res = await httpAction(this.url.queryProvince, {}, "post");
      if (res.code !== 200) return this.$message.error("获取数据失败");
        if (res.data && res.data.length) res.data.forEach(item => {item.hasChildren = true; item.type = 1; item.provinceCode = item.code;});
        this.routes = res.data;
    },
    async load(tree, treeNode, resolve) {
      if (!this.treeMap.has(tree.code)) {
          this.treeMap.set(tree.code, {
            treeNode,
            resolve
          })
        }
      if (tree.type === 1) {
        let res = await httpAction(this.url.queryCity, { provinceCode: tree.code }, "post");
        if (res.code !== 200) return this.$message.error("获取数据失败");
        if (res.data && res.data.length) res.data.forEach(item => {item.hasChildren = true; item.type = 2; item.cityCode = item.code;});
        resolve(res.data);
      }
      if (tree.type === 2) {
        let res = await httpAction(this.url.queryCounty, { cityCode: tree.code }, "post");
        if (res.code !== 200) return this.$message.error("获取数据失败");
        // res.data.forEach((item) => {item.cityCode = tree.code;});
        resolve(res.data);
      }
    },
     async addMenu() {
      let { name , code, type, provinceCode, cityCode } = this.form;
      if (!name) return this.$message.warning("请输入名称");
      if (!code) return this.$message.warning("请输入code");
      if (time !== null) clearTimeout(time)
      // time = setTimeout(async () => {
        if (!this.form.id) {
          let res = null
          if (!type) res = await httpAction('/pcc/saveProvince', {provinceName: name, provinceCode: code}, "post");
          if (type === 1) res = await httpAction('/pcc/saveCity', { provinceCode: provinceCode, cityName: name, cityCode: code}, "post");
          if (type === 2) res = await httpAction('/pcc/saveCounty', { cityCode: cityCode, countyName: name, countyCode: code}, "post");
          if (res.code === 200) {
            this.$message.success("新增成功");
            this.getProvinceRoutes();
            this.addMenuDialog = false;
          } else {
            this.$message.error(res.msg);
          }
        } else {
          let res = null
          if (!type){
            res = await httpAction('/pcc/updateProvince', {id: this.form.id, provinceName: this.form.name}, "post");
            // this.load({code: this.form.code}, this.treeMap.treeNode, this.treeMap.resolve)
          }
          if (type === 1) res = await httpAction('/pcc/updateCity', {id: this.form.id, cityName: this.form.name, provinceCode: this.form.pcode}, "post");
          if (type === 2) res = await httpAction('/pcc/updateCounty', {id: this.form.id, countyName: this.form.name, cityCode: this.form.pcode}, "post");
          if (res.code === 200) {
            this.$message.success("修改成功");
            // this.getProvinceRoutes();
            let treeObj = this.treeMap.get(this.form.pcode);
            if (this.form.pcode) this.load({type, code: this.form.pcode}, treeObj.treeNode, treeObj.resolve)
            else this.getProvinceRoutes();
            this.addMenuDialog = false;
          } else {
            this.$message.error(res.msg);
          }
        }
      // },1000)
    },
    changeAddMenuDialog(row) {
      this.menuTitle = '新增地区'
      this.form.name = "";
      this.form.code = "";
      // this.form.pcode = row.pcode ? row.pcode : "";
      this.form.type = row.type ? row.type : "";
      this.form.provinceCode = row.provinceCode ? row.provinceCode : "";
      this.form.cityCode = row.cityCode ? row.cityCode : "";
      this.addMenuDialog = true;
    },
    async editMenuAuth (row) {
      this.menuTitle = '修改菜单'
      if (row.type == 1) {
        let res = await httpAction('/pcc/queryProvinceInfo?id=' + row.id , {}, "get");
        this.form = res.data
      }
      if (row.type == 2) {
        let res = await httpAction('/pcc/queryCityInfo?id=' + row.id , {}, "get");
        this.form = res.data
        this.form.type = 1
      }
      if (!row.type) {
        let res = await httpAction('/pcc/queryCountyInfo?id=' + row.id , {}, "get");
        this.form = res.data
        this.form.type = 2
      }
      this.addMenuDialog = true;
    },
    async deleteMenuAuth (row) {
      let res = null;
      if (row.type == 1) res = await httpAction('/pcc/delProvince', {id: row.id}, "post");
      if (row.type == 2) res = await httpAction('/pcc/delCity', {id: row.id}, "post");
      if (!row.type) res = await httpAction('/pcc/delCounty', {id: row.id}, "post");
      if (res.code === 200) {
        this.$message.success("删除成功");
        this.getProvinceRoutes();
      } else {
        this.$message.warning("删除失败,请重新尝试");
      }
    }
  },
};
</script>

<style scoped lang="less">
.container {
  padding: 20px;
}
</style>
